import { render, staticRenderFns } from "./recentPost.vue?vue&type=template&id=11987620&"
import script from "./recentPost.vue?vue&type=script&lang=js&"
export * from "./recentPost.vue?vue&type=script&lang=js&"
import style0 from "./recentPost.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports